import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './BankDetail.css';

const Bankdetail = () => {
  const [accHolderName, setAccHolderName] = useState('');
  const [bankName, setBankName] = useState('');
  const [accNo, setAccNo] = useState('');
  const [reEnterAccNo, setReEnterAccNo] = useState('');
  const [ifscCode, setIfscCode] = useState('');
  const [accType, setAccType] = useState('current');
  const [epfNumber, setEpfNumber] = useState('');
  const [nominee, setNominee] = useState('');
  const [chequeImage, setChequeImage] = useState(null);
  const [chequeBase64, setChequeBase64] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('token');

    axios
      .get('https://api.ndtechland.com/api/EmployeeApi/GetBankdetail', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const data = response.data.data;
        setAccHolderName(data.accountHolderName || '');
        setBankName(data.bankName || '');
        setAccNo(data.accountNumber || '');
        setReEnterAccNo(data.reEnterAccountNumber || '');
        setIfscCode(data.ifsc || '');
        setAccType(data.accountTypeId === 2 ? 'saving' : 'current');
        setEpfNumber(data.epfNumber || '');
        setNominee(data.nominee || '');
        setChequeImage(data.chequebase64 ? `data:image/png;base64,${data.chequebase64}` : null);
      })
      .catch((error) => {
        console.error('Error fetching bank details:', error);
      });
  }, []);

  const handleChequeUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setChequeImage(reader.result);
        setChequeBase64(reader.result.split(',')[1]);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUpdate = () => {
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('AccountHolderName', accHolderName);
    formData.append('BankName', bankName);
    formData.append('AccountNumber', accNo);
    formData.append('ReEnterAccountNumber', reEnterAccNo);
    formData.append('Ifsc', ifscCode);
    formData.append('AccountTypeId', accType === 'saving' ? 2 : 1);
    formData.append('EpfNumber', epfNumber);
    formData.append('Nominee', nominee);
    formData.append('Chequebase64', chequeBase64);
    axios
      .post('https://api.ndtechland.com/api/EmployeeApi/EmployeeBankDetail', formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        console.log('Bank details updated successfully:', response.data);
        alert('Bank details updated successfully');
      })
      .catch((error) => {
        console.error('Error updating bank details:', error);
        alert('Error updating bank details');
      });
  };

  return (
    <div className="bank-detail-container">
      <div className="bank-detail-header">
        <div className="d-flex align-items-center gap-3">
          <span className="bank-header-icon">
            <i className="fas fa-university"></i>
          </span>
          <div>
            <h2>Bank Details</h2>
            <p className="bank-header-subtitle">Update and manage your salary account details</p>
          </div>
        </div>
      </div>
      <form className="bank-detail-form" onSubmit={(e) => { e.preventDefault(); handleUpdate(); }}>
        <div className="bank-form-grid">
          <div className="form-group">
            <label>ACC Holder Name:</label>
            <div className="input-with-icon">
              <i className="fas fa-user input-icon"></i>
              <input
                type="text"
                value={accHolderName}
                onChange={(e) => setAccHolderName(e.target.value)}
                placeholder="Enter account holder name"
                required
              />
            </div>
          </div>
          <div className="form-group">
            <label>Bank Name:</label>
            <div className="input-with-icon">
              <i className="fas fa-landmark input-icon"></i>
              <input
                type="text"
                value={bankName}
                onChange={(e) => setBankName(e.target.value)}
                placeholder="Enter bank name"
                required
              />
            </div>
          </div>
          <div className="form-group">
            <label>Acc No:</label>
            <div className="input-with-icon">
              <i className="fas fa-credit-card input-icon"></i>
              <input
                type="text"
                value={accNo}
                onChange={(e) => setAccNo(e.target.value)}
                placeholder="Enter account number"
                required
              />
            </div>
          </div>
          <div className="form-group">
            <label>Re-Enter Acc No:</label>
            <div className="input-with-icon">
              <i className="fas fa-check-double input-icon"></i>
              <input
                type="text"
                value={reEnterAccNo}
                onChange={(e) => setReEnterAccNo(e.target.value)}
                placeholder="Re-enter account number"
                required
              />
            </div>
          </div>
          <div className="form-group">
            <label>IFSC Code:</label>
            <div className="input-with-icon">
              <i className="fas fa-qrcode input-icon"></i>
              <input
                type="text"
                value={ifscCode}
                onChange={(e) => setIfscCode(e.target.value)}
                placeholder="Enter IFSC code"
                required
              />
            </div>
          </div>
          <div className="form-group">
            <label>Acc Type:</label>
            <div className="radio-group-wrapper">
              <label className={`radio-card ${accType === 'current' ? 'active' : ''}`}>
                <input
                  type="radio"
                  name="accType"
                  value="current"
                  checked={accType === 'current'}
                  onChange={(e) => setAccType(e.target.value)}
                />
                <i className="fas fa-briefcase me-2"></i>
                Current
              </label>
              <label className={`radio-card ${accType === 'saving' ? 'active' : ''}`}>
                <input
                  type="radio"
                  name="accType"
                  value="saving"
                  checked={accType === 'saving'}
                  onChange={(e) => setAccType(e.target.value)}
                />
                <i className="fas fa-piggy-bank me-2"></i>
                Saving
              </label>
            </div>
          </div>
          <div className="form-group">
            <label>EPF Number:</label>
            <div className="input-with-icon">
              <i className="fas fa-id-card input-icon"></i>
              <input
                type="text"
                value={epfNumber}
                onChange={(e) => setEpfNumber(e.target.value)}
                placeholder="Enter EPF number"
              />
            </div>
          </div>
          <div className="form-group">
            <label>Nominee:</label>
            <div className="input-with-icon">
              <i className="fas fa-user-shield input-icon"></i>
              <input
                type="text"
                value={nominee}
                onChange={(e) => setNominee(e.target.value)}
                placeholder="Enter nominee name"
              />
            </div>
          </div>
          <div className="form-group full-width">
            <label>Upload Cheque:</label>
            <div className="cheque-upload-box">
              <i className="fas fa-cloud-upload-alt cheque-cloud-icon"></i>
              <input
                type="file"
                accept="image/*"
                onChange={handleChequeUpload}
              />
            </div>
          </div>
        </div>

        <div className="update-container">
          <button type="button" className="update-button" onClick={handleUpdate}>
            <i className="fas fa-save me-2"></i> Update
          </button>
          {chequeImage && (
            <div className="cheque-preview">
              <h4>Uploaded Cheque:</h4>
              <img src={chequeImage} alt="Uploaded Cheque" />
            </div>
          )}
        </div>
      </form>
    </div>
  );
};

export default Bankdetail;
